export const ProductImagesProj = `#graphql
fragment ProductImagesProj on ProductImage {
  disabled
  label
  position
  url
}
`
